import React from 'react';

export interface SectionCardProps {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
  accent?: boolean;
}

export const SectionCard: React.FC<SectionCardProps> = ({ icon, title, children, accent = false }) => (
  <div className={`rounded-xl border p-6 ${accent ? 'bg-[#F5F7FA] border-[#e5e7eb]' : 'bg-white border-[#e5e7eb]'}`}>
    <h3 className="text-xs font-semibold text-[#18365E] uppercase tracking-wide mb-3 flex items-center gap-2">{icon}{title}</h3>
    {children}
  </div>
);

export default SectionCard;
